const initGenericListingWidget = () => {
    const filter = document.querySelector("[data-filter-component]");
    const internalGallerySelector = "[data-generic-listing-widget] [data-internal-gallery]";
    const internalGallery = document.querySelector(internalGallerySelector);
    let config = new CarouselConfig();
    const responsiveCarousel = new ResponsiveCarousel();
    if (internalGallery) {
        setTimeout(() => {
            config = new CarouselConfig();
            config.sliderSelector = internalGallerySelector;
            config.cellAlign = CellAlign.center;
            config.contain = true;
            config.autoPlay = false;
            config.wrapAround = true;
            config.showArrows = false;
            config.adaptiveHeight = false;
            config.showDots = false;
            config.groupCells = false;
            config.adaptiveHeight = false;
            config.imagesLoaded = true;
            config.activateCustomButtons = true;
            const createdGalleryArray = responsiveCarousel.initCarousel(config);
        }, 200);
    }
    if (filter) {
        const filterOpener = filter.querySelector("[data-filter-opener]");
        const filterContainer = filter.querySelector("[data-filter-container]");
        const filterItemList = filterContainer === null || filterContainer === void 0 ? void 0 : filterContainer.querySelectorAll("[data-filter-item]");
        const submit = filterContainer === null || filterContainer === void 0 ? void 0 : filterContainer.querySelector("[data-cta-submit]");
        const reset = filterContainer === null || filterContainer === void 0 ? void 0 : filterContainer.querySelector("[data-cta-reset]");
        filterOpener === null || filterOpener === void 0 ? void 0 : filterOpener.addEventListener("click", () => {
            filterContainer.classList.toggle("active");
        });
        submit.addEventListener("click", (e) => {
            e.preventDefault();
            const url = new URL(window.location.href.replace(window.location.search, ''));
            url.searchParams.append(`listing-page-id`, `${filter.getAttribute("data-filter-component")}`);
            filterItemList.forEach((filterItem) => {
                const option = filterItem.querySelector("[data-input]");
                if (option.checked == true) {
                    url.searchParams.append(`${option.getAttribute('id')}`, `1`);
                }
            });
            fetchFilterResult(url);
            url.searchParams.delete("listing-page-id");
            window.history.replaceState(null, null, `${url.href}`);
        });
        reset.addEventListener("click", (e) => {
            e.preventDefault();
            filterItemList.forEach((filterItem) => {
                const option = filterItem.querySelector("[data-input]");
                option.checked = false;
            });
        });
    }
};
const fetchFilterResult = (url) => {
    fetch(`${url.href}`)
        .then(data => {
        //hide old pagination
        const oldPaginationComponent = document.querySelector("[data-pagination-component]");
        //convert the response into plain text
        data.text()
            //resolve the promise
            .then((result) => {
            // Initialize the DOM parser
            const parser = new DOMParser();
            // Parse the text and convert it into HTML
            const parsedHTML = parser.parseFromString(result, "text/html");
            //append them to the deck
            //if the id matches
            const dataContainer = document.querySelector(`[data-container-loadmore]`);
            const cardsToAppendArray = parsedHTML.querySelectorAll("[data-to-append]");
            dataContainer.innerHTML = "";
            cardsToAppendArray.forEach(cardsToAppend => {
                dataContainer.append(cardsToAppend);
            });
            //add animation
            const configCardsAnimationLoadMore = new CardAnimationConfig();
            configCardsAnimationLoadMore.delay = 300;
            configCardsAnimationLoadMore.cardsToAnimateNodeList = cardsToAppendArray;
            const cardAnimationLoadMore = new CardAnimation;
            cardAnimationLoadMore.initCardsAnimation(configCardsAnimationLoadMore);
            //print new pagination
            const newPaginationComponent = parsedHTML.querySelector("[data-pagination-component]");
            if (newPaginationComponent) {
                if (oldPaginationComponent) {
                    oldPaginationComponent.innerHTML = newPaginationComponent.innerHTML;
                }
                else {
                    dataContainer.parentElement.appendChild(newPaginationComponent);
                }
            }
            else {
                if (oldPaginationComponent) {
                    oldPaginationComponent.remove();
                }
            }
            //bind the events again
            initPaginationComponent();
            //scroll to deck start
            dataContainer.scrollIntoView();
        });
    });
};
